import { FC } from "react";

const Books: FC = () => {
  return <div> List of books recommended </div>;
};

export default Books;
